/* src/app/modules/invoice/invoices-statistics/invoices-statistics.component.css */
/*# sourceMappingURL=invoices-statistics.component.css.map */
